import { Form } from 'react-bootstrap';

const Select = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  options,
  dropDownClassName,
  placeholder,
}) => (
  <div className={className}>
    {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
    <Form.Select
      name={name}
      aria-label={label}
      value={value}
      className={dropDownClassName}
      onChange={onChange}
    >
      {placeholder && <option defaultChecked value="">{placeholder || 'Select an Option'}</option>}
      {options.map((option) => (
        <option
          key={`${name}-${option.value}`}
          value={option.value}
          className={inputClassName}
        >
          {option.label}
        </option>
      ))}
    </Form.Select>
  </div>
);

export default Select;
